/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import NewSidebar from './components/sidebar/NewSidebar'

const AdminLayout: React.FC = () => {
  const location = useLocation()
  const [collapsed, setCollapsed] = useState(false)
  const appName = process.env.REACT_APP_APP_NAME ?? 'CandiHealth'
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  // Auto-collapse sidebar on small screens (layout-level)
  useEffect(() => {
    if (typeof window === 'undefined') return

    const mq = window.matchMedia('(max-width: 767px)')
    // set initial collapsed state
    setCollapsed(mq.matches)

    const listener = (e: MediaQueryListEvent | MediaQueryList) => {
      const matches = (e as MediaQueryListEvent).matches ?? (e as MediaQueryList).matches
      setCollapsed(Boolean(matches))
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', listener as EventListener)
    } else {
      // legacy fallback
      // @ts-ignore
      mq.addListener(listener)
    }

    return () => {
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', listener as EventListener)
      } else {
        // @ts-ignore
        mq.removeListener(listener)
      }
    }
  }, [])

  return (
    <PageDataProvider>
      <div className='d-flex' style={{minHeight: '100vh'}}>
        {/* Sidebar container tracks `collapsed` */}
        <div
          className='flex-shrink-0'
          style={{
            width: collapsed ? '72px' : '240px',
            transition: 'width 0.3s ease-in-out',
          }}
        >
          <NewSidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} appName={appName} />
        </div>

        {/* Main content */}
        <div className='flex-grow-1 d-flex flex-column' style={{minWidth: 0}}>
          <HeaderWrapper />

          <div className='flex-grow-1 overflow-auto d-flex flex-column'>
            <ToolbarWrapper />
            <Content>
              <Outlet />
            </Content>
          {/* make footer scroll with body */}
          <FooterWrapper />
          </div>

        </div>
      </div>

      <ScrollTop />
    </PageDataProvider>
  )
}

export default AdminLayout
